import { useEffect, useRef } from 'react';

function useUpdateOnlyEffect(callback: () => any, dependencies: ReadonlyArray<any>) {
  const firstRender = useRef(true);

  useEffect(() => {
    if (!firstRender.current) {
      return callback();
    }

    firstRender.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...dependencies, callback]);
}

export default useUpdateOnlyEffect;
